import JobOffers from './JobOffers';

export default JobOffers;
